import { useTranslation } from 'react-i18next';
import React, { memo, ReactNode } from 'react';
import cx from 'clsx';

import { IconNoUsers } from '@/assets/proposals';
import { Card } from '@/components';
import { IconEmptyDark, IconEmptyLight } from '@/assets/components/EmptyRecord';

import './index.scss';
import { useTheme } from '@/hooks';

type EmptyRecordProps = {
  className?: string;
  content?: ReactNode;
  iconType?: 'record' | 'user';
};

export const EmptyRecord = memo(({ className, content, iconType = 'record' }: EmptyRecordProps) => {
  const { t } = useTranslation();
  const { isDark } = useTheme();

  const IconDict = {
    record: isDark ? IconEmptyDark : IconEmptyLight,
    user: IconNoUsers,
  };

  return (
    <div className={cx('db-empty-table', className)}>
      <img className="db-empty-icon" src={IconDict[iconType] || IconDict.record} alt="empty" />
      <div className="db-empty-title">{content || t('EmptyRecord.noRecords')}</div>
    </div>
  );
});

export const EmptyRecordMobile = memo(
  ({ className, content, iconType = 'record' }: EmptyRecordProps) => {
    const { t } = useTranslation();
    const { isDark } = useTheme();

    const IconDict = {
      record: isDark ? IconEmptyDark : IconEmptyLight,
      user: IconNoUsers,
    };
    return (
      <div className={cx('db-empty-table-mobile', className)}>
        <img
          className="db-empty-icon-mobile"
          src={IconDict[iconType] || IconDict.record}
          alt="empty"
        />
        <div className="db-empty-title-mobile">{content || t('EmptyRecord.noRecords')}</div>
      </div>
    );
  },
);

export const InvalidAddress = memo(() => {
  const { t } = useTranslation();

  return <Card className="db-invalid-address">{t('EmptyRecord.q1cu9b')}</Card>;
});
